module.exports = __webpack_public_path__ + "img/tag-02.aed72928.svg";